class PortrateGridController {
	isGrid = true;
	gridConfig = null;
	views = null;
	debug = null;
	debugColors = [
		'#00FF00',
		'#32CD32',
		'#98FB98',
		'#90EE90',
		'#00FA9A',
		'#00FF7F',
		'#3CB371',
		'#2E8B57',
		'#00BFFF',
		'#1E90FF',
		'#4169E1',
		'#0000FF',
		'#0000CD',
		'#00008B',
		'#000080',
		'#191970',
		'#FFA07A',
		'#FA8072',
		'#E9967A',
		'#F08080',
		'#CD5C5C',
		'#DC143C',
		'#FF0000',
		'#B22222',
		'#8B0000'
	];

	origins = {};

	constructor(vc, origins, conf, debug) {
		this.origins = origins;
		this.vc = vc;
		this.debug = debug;
		this.debug = null;
		this.config = conf;
		// console.log(this.config, 'this config')
		if (this.config.portrate === null && this.config.main === null) {
			throw new Error(
				'PortrateGridController failed init, portrate and main blocks is null ' +
					JSON.stringify(this.config)
			);
		}
	}

	getBounds() {
		return {
			width: 100,
			height: 100
		};
	}

	resize(x, y, w, h) {
		if (this.config.hide) {
			for (let index = 0; index < this.config.hide.length; index++) {
				const element = this.config.hide[index];
				let hideElement = this.vc.getChildByName(element, true);
				if (hideElement != null) {
					hideElement.visible = false;
				} else {
					console.log('Invalid hide element ', element);
				}
			}
		}

		if (this.config.unhide) {
			for (let index = 0; index < this.config.unhide.length; index++) {
				const element = this.config.unhide[index];
				let unhideElement = this.vc.getChildByName(element, true);
				if (unhideElement != null) {
					unhideElement.visible = true;
				} else {
					console.log('Invalid unhideElement element ', element);
				}
			}
		}

		let size = this.getSize(this.config, x, y, w, h);
		/*if (this.debug) {
            this.debug.lineStyle(6, 0x00ff00);
            this.debug.drawRect(
                size.left,
                size.top,
                size.width - 6,
                size.height - 6
            );
        }*/

		let gridSize = size.height / this.config.size;

		let gap = size.height * (this.config.gap / 100);
		let conf = this.config.portrate;
		if (conf == null) {
			conf = this.config.main;
		}
		let elementTop = size.top;
		for (let i = 0; i < conf.length; i++) {
			const element = conf[i];
			if (element.visible === false) {
				//hide element
				let viewElement = this.vc[element.name];
				viewElement.visible = false;
			} else {
				let elHeight = gridSize * element.size - gap;
				let viewSize = {
					top: elementTop,
					left: size.left,
					width: size.width,
					height: elHeight
				};
				if (element.name !== 'empty') {
					let viewElement = this.vc[element.name];
					viewElement.visible = true;
					this.repositionView(viewElement, viewSize, element);
				}

				if (this.debug) {
					this.debugDrawRect(viewSize);
				}
				elementTop = elementTop + gap + elHeight;
			}
		}
	}

	repositionView(current, size, cfg) {
		if (current.isGrid) {
			current.resize(size.left, size.top, size.width, size.height);
		} else {
			let origin = this.origins[cfg.name];
			let height = size.height;
			let width = size.width;

			let hScale = 1;
			let wSacale = 1;
			if (cfg.height) {
				height = height * (cfg.height / 100);
				hScale = cfg.height / 100;
			}
			if (cfg.width) {
				width = width * (cfg.width / 100);
				wSacale = cfg.width / 100;
			}

			let scale = Math.min(width / origin.width, height / origin.height);

			let offsetPos = { x: 0, y: 0 };

			if (current.isButton) {
				offsetPos.x = (origin.width * scale) / 2;
				offsetPos.y = (origin.height * scale) / 2;
			}

			if (cfg.bounds !== undefined) {
				if (cfg.bounds.offsetX !== undefined) {
					offsetPos.x = offsetPos.x + cfg.bounds.offsetX;
				}
				if (cfg.bounds.offsetY !== undefined) {
					offsetPos.y = offsetPos.y + cfg.bounds.offsetY;
				}
			}

			offsetPos.x = offsetPos.x + (width - origin.width * wSacale * scale) / 2;
			offsetPos.y =
				offsetPos.y + (size.height - origin.height * hScale * scale) / 2;

			if (cfg.align) {
				switch (cfg.align) {
					case 'top':
						offsetPos.y = 0;
						break;
					case 'left':
						offsetPos.x = 0;
						break;
					case 'right':
						offsetPos.x = width - origin.width * scale;
						break;
					case 'bottom_center':
						offsetPos.y = size.height - origin.height * scale;
						break;
					case 'left_center':
						offsetPos.x = 0;
						offsetPos.y = (size.height - origin.height * scale) / 2;
						break;
					case 'right_center':
						offsetPos.x = width - origin.width * scale;
						offsetPos.y = (size.height - origin.height * scale) / 2;
						break;
					case 'top_center':
						offsetPos.y = 0;
						break;
					case 'top_right':
						offsetPos.y = 0;
						offsetPos.x = width - origin.width * scale;
						break;
					case 'top_left':
						offsetPos.y = 0;
						offsetPos.x = 0;
						break;
					case 'bottom_left':
						offsetPos.x = 0;
						offsetPos.y = size.height - origin.height * scale;
						break;
					case 'bottom_right':
						offsetPos.y = size.height - origin.height * scale;
						offsetPos.x = width - origin.width * scale;
						break;
					default:
						break;
				}
			}

			offsetPos.x = offsetPos.x + size.left;
			offsetPos.y = offsetPos.y + size.top;

			current.position.set(offsetPos.x, offsetPos.y);

			current.scale.set(scale, scale);
		}
	}

	debugDrawRect(size, main) {
		let debugColor =
			this.debugColors[Math.floor(Math.random() * this.debugColors.length)];
		this.debug.clear();
		this.debug.lineStyle(main ? 3 : 2, debugColor);
		this.debug.drawRect(size.left, size.top, size.width, size.height);
	}

	getSize(cfg, x, y, w, h) {
		let padding = {
			top: 0,
			bottom: 0,
			left: 0,
			right: 0
		};

		if (cfg.padding !== undefined) {
			padding.top = cfg.padding.top === undefined ? 0 : cfg.padding.top;
			padding.bottom =
				cfg.padding.bottom === undefined ? 0 : cfg.padding.bottom;
			padding.left = cfg.padding.left === undefined ? 0 : cfg.padding.left;
			padding.right = cfg.padding.right === undefined ? 0 : cfg.padding.right;

			if (cfg.padding.portrate !== undefined) {
				padding.top =
					cfg.padding.portrate.top === undefined ? 0 : cfg.padding.portrate.top;
				padding.bottom =
					cfg.padding.portrate.bottom === undefined
						? 0
						: cfg.padding.portrate.bottom;
				padding.left =
					cfg.padding.portrate.left === undefined
						? 0
						: cfg.padding.portrate.left;
				padding.right =
					cfg.padding.portrate.right === undefined
						? 0
						: cfg.padding.portrate.right;
			}
		}

		let topPos = y + (h * padding.top) / 100;
		let leftPos = x + (w * padding.left) / 100;
		let height = h - (h * (padding.top + padding.bottom)) / 100;
		let width = w - (w * (padding.left + padding.right)) / 100;

		return {
			top: parseInt(topPos),
			left: parseInt(leftPos),
			width: parseInt(width),
			height: parseInt(height)
		};
	}
}

export default PortrateGridController;
